/**
 * Politique anti-traduction navigateur pour toute l'app.
 * La traduction auto (Chrome/Edge) mute le DOM et provoque NotFoundError sur removeChild.
 * L'i18n applicatif (fr/en/cn) reste la seule source de langue.
 */
export function applyNoTranslatePolicy(): void {
  if (typeof document === "undefined") {
    return;
  }

  const mark = (el: Element | null) => {
    if (!el) return;
    el.setAttribute("translate", "no");
    el.classList.add("notranslate");
  };

  mark(document.documentElement);
  mark(document.body);
  mark(document.getElementById("root"));

  const existing = document.querySelector(
    'meta[name="google"][content="notranslate"]'
  );
  if (!existing) {
    const meta = document.createElement("meta");
    meta.name = "google";
    meta.content = "notranslate";
    document.head.appendChild(meta);
  }
}

/** Props HTML à coller sur les wrappers de layout (défense en profondeur). */
export const NO_TRANSLATE_PROPS = {
  translate: "no" as const,
  className: "notranslate",
};
